import React, { useState } from 'react';

const formatDate = (value) => value ? new Date(value).toLocaleString('ru-RU') : '—';
const formatDuration = (seconds) => {
  const value = Math.max(0, Number(seconds || 0));
  const d = Math.floor(value / 86400);
  const h = Math.floor((value % 86400) / 3600);
  const m = Math.floor((value % 3600) / 60);
  if (d) return `${d}д ${h}ч`;
  if (h) return `${h}ч ${m}м`;
  if (m) return `${m}м`;
  return `${Math.round(value)}с`;
};

const SystemMonitorUserHistory = ({ data, loading, onClose }) => {
  const [tab, setTab] = useState('sessions');
  if (!data && !loading) return null;

  const totals = data?.totals || {};
  const isVisitor = data?.type === 'visitor' || Boolean(data?.visitorId && !data?.user);
  const title = isVisitor
    ? `Посетитель #${String(data?.visitorId || '').slice(-8).toUpperCase()}`
    : (data?.user?.name || 'История пользователя');
  const subtitle = isVisitor
    ? `ID посетителя: ${data?.visitorId || '—'}`
    : `${data?.user?.email || ''}${data?.user?.role ? ` · ${data.user.role}` : ''}`;

  return (
    <div className="systemMonitor__historyOverlay" onClick={onClose}>
      <div className="systemMonitor__historyModal is-wide" onClick={(e) => e.stopPropagation()}>
        <div className="systemMonitor__sectionHead">
          <div>
            <div className="systemMonitor__historyTitleRow"><div className="systemMonitor__avatar">{isVisitor ? 'Г' : String(title || 'П').charAt(0).toUpperCase()}</div><div><div className="systemMonitor__sectionTitle">{loading ? 'Загрузка истории…' : title}</div><div className="systemMonitor__sectionHint">{subtitle}</div></div></div>
          </div>
          <button type="button" className="systemMonitor__miniBtn" onClick={onClose}>Закрыть</button>
        </div>

        {loading ? <div className="systemMonitor__empty">Загрузка истории…</div> : (
          <>
            {isVisitor && data?.linkedUsers?.length ? <div className="systemMonitor__linkedIdentity"><span>Связанные аккаунты:</span>{data.linkedUsers.map((user) => <b key={user._id}>{user.name} · {user.email || user.role}</b>)}</div> : null}
            {!isVisitor && data?.visitorIds?.length ? <div className="systemMonitor__linkedIdentity"><span>Связанные ID посетителя:</span><b>{data.visitorIds.length}</b><small>В историю пользователя включены гостевые сессии этого браузера до авторизации.</small></div> : null}

            <div className="systemMonitor__statsGrid is-compact">
              <div className="systemMonitor__statCard"><span>Сессий</span><strong>{totals.sessions || 0}</strong>{totals.linkedGuestSessions ? <small>из них гостевых {totals.linkedGuestSessions}</small> : null}</div>
              <div className="systemMonitor__statCard"><span>Активное время</span><strong>{formatDuration(totals.activeSeconds)}</strong></div>
              <div className="systemMonitor__statCard"><span>Страниц</span><strong>{totals.pageViews || 0}</strong></div>
              <div className="systemMonitor__statCard"><span>API-запросов</span><strong>{totals.apiRequests || 0}</strong><small>{totals.apiErrors || 0} ошибок</small></div>
              <div className="systemMonitor__statCard"><span>Socket.IO событий</span><strong>{totals.socketEvents || 0}</strong></div>
              <div className="systemMonitor__statCard"><span>Первый визит</span><strong className="is-date">{formatDate(totals.firstSeenAt)}</strong></div>
              <div className="systemMonitor__statCard"><span>Последний визит</span><strong className="is-date">{formatDate(totals.lastSeenAt)}</strong></div>
            </div>

            <div className="systemMonitor__peopleTabs is-modal">
              <button type="button" className={tab === 'sessions' ? 'is-active' : ''} onClick={() => setTab('sessions')}>Сессии <span>{data?.sessions?.length || 0}</span></button>
              <button type="button" className={tab === 'routes' ? 'is-active' : ''} onClick={() => setTab('routes')}>Переходы <span>{data?.visits?.length || 0}</span></button>
            </div>

            {tab === 'sessions' ? <div className="systemMonitor__historySessions">
              {(data?.sessions || []).map((session) => (
                <article className="systemMonitor__historySession" key={session.sessionId}>
                  <div className="systemMonitor__historySessionHead"><div><span className={`systemMonitor__appBadge is-${session.source || 'front'}`}>{session.source === 'admin' ? 'АДМИНКА' : 'САЙТ'}</span><strong>{formatDate(session.startedAt)}</strong></div><b>{formatDuration(session.activeSeconds)}</b></div>
                  <div className="systemMonitor__historySessionGrid"><span><small>Маршрут</small>{session.lastRoute || session.firstRoute || '/'}</span><span><small>Устройство</small>{session.deviceLabel || '—'} · {session.browserLabel || '—'}</span><span><small>IP</small>{session.ip || '—'}</span><span><small>Страниц</small>{session.pageViews || 0}</span><span><small>API / Socket</small>{session.apiRequests || 0} / {session.socketEvents || 0}</span><span><small>Последняя активность</small>{formatDate(session.lastSeenAt)}</span></div>
                </article>
              ))}
              {!data?.sessions?.length ? <div className="systemMonitor__empty">Сохранённых сессий пока нет.</div> : null}
            </div> : null}

            {tab === 'routes' ? <div className="systemMonitor__historyTimeline">
              {(data?.visits || []).slice(0, 1200).map((visit) => (
                <div className="systemMonitor__historyRow" key={visit.visitId}>
                  <div><strong>{visit.route}</strong><small>{visit.source?.toUpperCase()}</small></div>
                  <div>{formatDate(visit.enteredAt)}</div>
                  <div>{formatDuration(visit.activeSeconds)}</div>
                </div>
              ))}
              {!data?.visits?.length ? <div className="systemMonitor__empty">Сохранённых переходов пока нет.</div> : null}
            </div> : null}
          </>
        )}
      </div>
    </div>
  );
};

export default SystemMonitorUserHistory;
